module.exports = __webpack_public_path__ + "static/media/Hoopers02.5a7c654e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Hoopers02.jpg
// module id = 351
// module chunks = 0